module.exports = __webpack_public_path__ + "static/media/7x7GoodOptimized.ef833ea9.png";